/**
 * App Bridge Support Handler
 * Registers custom support callback for when merchants click "Get Support" in Shopify admin
 */

import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

export function SupportHandler() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Register support handler with App Bridge
    // This requires the app to have a support link extension configured in Shopify Partner Dashboard
    if (typeof window !== 'undefined' && window.shopify) {
      try {
        const shopify = window.shopify;
        const queryString = searchParams.toString();

        // Register callback for support button using App Bridge support API
        shopify.support.registerHandler(() => {
          // Navigate to support page when help button clicked in Shopify admin
          const supportUrl = `/app/support${queryString ? `?${queryString}` : ''}`;
          navigate(supportUrl);
        });
        // Support handler registered successfully
      } catch (error) {
        // Support handler registration failed - non-critical, silent fail
      }
    }
  }, [navigate, searchParams]);

  // This component doesn't render anything
  return null;
}
